export default __webpack_public_path__ + "static/media/IQAC.1d189ee7.png";